export default (): boolean => {
    return document.body.classList.contains("neos-backend");
}
